import React from "react";
import { motion } from "framer-motion";

/**
 * Premium horizontal-on-desktop / vertical-on-mobile timeline.
 * steps: [{ number: "01", title, description, icon: LucideComponent }]
 */
export const Timeline = ({ steps, "data-testid": testId }) => {
    return (
        <ol
            className="relative mt-14 grid grid-cols-1 gap-10 lg:grid-cols-4 lg:gap-6"
            data-testid={testId}
        >
            {/* Desktop connector line */}
            <span
                aria-hidden
                className="hidden lg:block absolute left-0 right-0 top-7 h-px"
                style={{
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,255,255,0.08) 12%, rgba(255,255,255,0.08) 88%, transparent)",
                }}
            />
            {steps.map((step, i) => {
                const Icon = step.icon;
                return (
                    <motion.li
                        key={step.number}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{
                            duration: 0.7,
                            delay: i * 0.08,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="relative flex gap-5 lg:block"
                    >
                        {/* Mobile connector */}
                        {i !== steps.length - 1 && (
                            <span
                                aria-hidden
                                className="lg:hidden absolute left-[27px] top-[60px] bottom-[-40px] w-px"
                                style={{ background: "rgba(255,255,255,0.08)" }}
                            />
                        )}

                        {/* Number badge */}
                        <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-border-subtle bg-elevated">
                            <span
                                className="font-display text-[13px] font-semibold tracking-tight-2 text-[var(--accent)]"
                                style={{
                                    textShadow: "0 0 12px rgba(124,255,79,0.35)",
                                }}
                            >
                                {step.number}
                            </span>
                        </div>

                        <div className="lg:mt-7">
                            <div className="flex items-center gap-2">
                                {Icon && (
                                    <Icon
                                        className="h-4 w-4 text-text-muted"
                                        strokeWidth={1.5}
                                    />
                                )}
                                <h3 className="font-display text-[18px] font-semibold leading-tight text-text-primary">
                                    {step.title}
                                </h3>
                            </div>
                            <p className="mt-2 max-w-[36ch] text-[14.5px] leading-[1.65] text-text-secondary">
                                {step.description}
                            </p>
                        </div>
                    </motion.li>
                );
            })}
        </ol>
    );
};

export default Timeline;
